import { timeUnitMap } from '../../../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/FTFCBoxes';
import { sequenceMap } from '../../../addAlertComponent/addAlertForm/formComponents/setup/setupDetails/setupDetailsModules/candlePattern/candlePatternMap';

export function parseCandlePatternNotificationDetails(notification) {
  const setupTemplate = notification.statusDetails.setupTemplate;
  const translatedPattern =
    setupTemplate.triggeredSetupPattern
      .split('-')
      .map((sequence) => sequenceMap[sequence])
      .join('-');
  const setupString = 'Candle Pattern-' + setupTemplate.candleDuration + timeUnitMap[setupTemplate.timeUnit];
  return {
    tactic: setupString,
    price: translatedPattern,
  };
}




// {
//   "messageType": "alertNotification",
//   "notificationId": 1643916005143,
//   "notificationType": "TRADE_PLAN_ALERT",
//   "typeDetails": {
//       "watchlistName": "test3",
//       "id": 1643924584961
//   },
//   "status": "SETUP_TRIGGERED",
//   "statusDetails": {
//       "setupName": "CANDLE_PATTERN",
//       "triggerPrice": 107.2382503468591,
//       "tradeDirection": "SHORT",
//       "symbol": "AMD",
//       "setupTemplate": {
//           "candleDuration": 1,
//           "timeUnit": "MINUTES",
//           "triggeredSetupPattern": "OUTSIDE_CANDLE-INSIDE_CANDLE-BREAK_LOW"
//       }
//   },
//   "date": "2022-02-03T17:02:09.700-0500",
//   "timestamp": "1643925729701"
// }
